import './header.scss';

import './img/eur.svg';
import './img/rub.svg';
import './img/uah.svg';
import './img/usd.svg';

$(function(){
  $('#mobile_menu').on('show.bs.collapse', function () {
    $(".flex_hamburger").addClass("flex_hamburger--close");
  });

  $('#mobile_menu').on('hide.bs.collapse', function () {
    $(".flex_hamburger").removeClass("flex_hamburger--close");
  });

  if($(window).width() < 1024){
    $('.menu-item .dropdown-toggle').click(function(){
      $(this).parent().siblings('.dropdown-menu').toggleClass('show');
    });
  }

});
